// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"71bd50f8","364":"71bd50f8","396":"71bd50f8","501":"71bd50f8","573":"c1aa8b21","587":"71bd50f8","670":"71bd50f8","743":"71bd50f8","754":"71bd50f8","905":"71bd50f8"}[chunkId] + ".chunk.css";
};